module.exports = __webpack_public_path__ + "static/media/AlienLeagueGradientBold-MPEB.43e42187.otf";